export const  addUser = (user)=>{
 return {type:'CREATE_USER',payload:user}
}
export const updateUser = (user)=>{ 
    return {type:'UPDATE_USER',payload:user}
} 
export const deleteUser = (user)=>{ 
    return {type:'DELETE_USER',payload:user}
}
export const showUser = (user)=>{ 
    return {type:'SHOW_USER',payload:user}
}